import { useAmountsContext } from '@components/amounts-received/hooks/use-amounts-context/use-amounts-context.hook'
import { IAmount } from '@components/amounts-received/hooks/use-amounts/use-amounts.hook'
import { useTranslation } from 'react-i18next'

import './description.component.scoped.scss'

const Description = () => {
  const { state }: IAmount = useAmountsContext()
  const { qtdCampaigns } = state
  const { t } = useTranslation('amounts')
  return (
    <div className="description">
      <span dangerouslySetInnerHTML={{ __html: t('totalCampaignsDescription', { count: qtdCampaigns }) }} />
    </div>
  )
}

export default Description
